import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { setSelectedAccident } from "../../../../actions/accidentDashboard";
import { getAccidents } from "../../../../actions/accidents";
import AccidentTable from "../../../commons/table/accidentTable";
import AccidentDashboardContainer from "../accidentDashboard/accidentDashboardContainer";
import EditAccidentContainer from "../edit/editAccidentContainer";
import CloseAccident from "../modal/closeAccident";

const SiniestrosContainer = () => {
  const dispatch = useDispatch();

  const accidents = useSelector((state) => state.accidents);
  const art = useSelector((state) => state.art.list);
  const documentation = useSelector(
    (state) => state.accidentDashboard.availableDocumentsToAdd,
  );

  const [displayAccidents, setDisplayAccidents] = useState("block");
  const [accidentToEdit, setAccidentToEdit] = useState(null);
  const [openModalCloseAccident, setOpenModalCloseAccident] = useState(false);
  const [accident, setAccident] = useState(null);
  const [openMessageAlert, setOpenMessageAlert] = useState(false);

  useEffect(() => {
    dispatch(getAccidents());
  }, []);

  const handleAccidentDetail = (accident) => {
    if (accident.tieneMensajesPendientes && accident.mostrarAlertaMensajeria) {
      setOpenMessageAlert(true);
    }
    dispatch(setSelectedAccident({ ...accident }));
    setDisplayAccidents("none");
  };

  const handleCloseModal = () => {
    setOpenModalCloseAccident(false);
  };

  const handleOpenModal = (accident) => {
    setAccident(accident);
    setOpenModalCloseAccident(true);
  };

  const handleCloseMessageAlert = () => {
    setOpenMessageAlert(false);
  };
  return (
    <div>
      {displayAccidents === "none" && (
        <AccidentDashboardContainer
          setDisplayAccidents={setDisplayAccidents}
          traslado={documentation.data.find((f) => f.formulario === "Fpt")}
        />
      )}
      <AccidentTable
        data={accidents.list}
        namesArts={art}
        loading={accidents.isFetching}
        error={accidents.didInvalidate}
        fetchData={() => dispatch(getAccidents())}
        handleAccidentDetail={handleAccidentDetail}
        displayAccidents={displayAccidents}
        handleEdit={(accident) => setAccidentToEdit(accident)}
        openModalCloseAccident={handleOpenModal}
      />
      <EditAccidentContainer
        accident={accidentToEdit}
        handleClose={() => setAccidentToEdit(null)}
      />

      <CloseAccident
        accident={accident}
        open={openModalCloseAccident}
        handleClose={handleCloseModal}
      />

      <Dialog open={openMessageAlert} onClose={handleCloseMessageAlert}>
        <DialogTitle>Mensajería</DialogTitle>
        <DialogContent>
          <DialogContentText>
            El siniestro posee mensajes sin leer o pendientes de respuesta.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMessageAlert} color="primary" autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SiniestrosContainer;
